import { ESubmissionItemStatus, TResolvedSubmissionItem } from '../types/submissions.types';
import { toPercent } from '@shared/utils/percent';

/**
 * Returns stats for the submission in the view-submission screen:
 *
 *  - totalCount: # of active items (still present in resolvedItems, not excluded)
 *  - acceptedCount: how many of those active items have status=ACCEPTED
 *  - progressPct: acceptedCount / totalCount * 100 (rounded)
 */
const getSubmissionStats = (
  resolvedSelectedItems: TResolvedSubmissionItem[]
): {
  totalCount: number;
  acceptedCount: number;
  progressPct: number;
} => {
  if (resolvedSelectedItems.length <= 0) {
    return {
      totalCount: 0,
      acceptedCount: 0,
      progressPct: 0,
    };
  }

  // 1) Calculate how many are accepted
  const accepted = resolvedSelectedItems.filter((item) => item.status === ESubmissionItemStatus.ACCEPTED);

  // 2) Derive the percentage
  const totalCount = resolvedSelectedItems.length;
  const acceptedCount = accepted.length;
  const progressPct = toPercent(acceptedCount, totalCount);

  // 3) Return everything in one object
  return {
    totalCount,
    acceptedCount,
    progressPct,
  };
};

export default getSubmissionStats;
